import React, { useEffect } from 'react';

import InputBase from 'apps/auth/components/form-multi/InputBase';
import { buildBackendRegExp } from 'apps/auth/components/form-multi/utils';
import { inputPropType } from 'apps/auth/helpers/customPropTypes';
import Inputmask from 'inputmask';

function useMask() {
    useEffect(() => {
        const selector = document.getElementById('inputMaskCardExp');
        Inputmask({
            placeholder: '__/__',
            showMaskOnHover: false,
        }).mask(selector);
    }, []);
}

const calcRegex = () => {
    const currentDate = new Date();
    const currentYear = String(currentDate.getFullYear());
    const sliceTwoLastDigit = currentYear.slice(2);
    const currYearDigitFirst = Number(sliceTwoLastDigit[0]);
    const currYearDigitSecond = Number(sliceTwoLastDigit[1]);
    return `^(0[1-9]|1[0-2])/(([${currYearDigitFirst}-9][${currYearDigitSecond}-9])|([${currYearDigitFirst + 1}-9][0-9]))$`;
};

const CardExpiredFieldHOC = ({ field, ...props }) => {
    useMask();

    const onHandlerBlur = (e) => {
        props.onBlur?.(e);
        const value = e.target.value;
        const valid = buildBackendRegExp(field.checkRegexp);
        if (valid.test(value)) {
            if (!props.isExpiryValid(value)) {
                props.setFieldError(props.formName, field.name, props.errorMessage);
            }
        }
    };

    const onKeyDownHandler = (e) => {
        const value = e.target.value;
        const valid = buildBackendRegExp(field.checkRegexp);
        const validValue = valid.test(value);
        if (e.keyCode === 13 && validValue) {
            if (valid.test(value)) {
                if (!props.isExpiryValid(value)) {
                    e.preventDefault();
                    props.setFieldError(props.formName, field.name, props.errorMessage);
                    e.target.blur();
                }
            }
        }
    };

    return (
        <input
            type="tel"
            autoComplete="off"
            id="inputMaskCardExp"
            data-inputmask-regex={calcRegex()}
            value={field.value ?? ''}
            readOnly={field.isReadOnly}
            onFocus={props.onFocus}
            onChange={props.onChange}
            onBlur={onHandlerBlur}
            name={field.name}
            ref={props.forwardedRef}
            onKeyDown={onKeyDownHandler}
        />
    );
};

const CardExpiredField = InputBase(CardExpiredFieldHOC, true);

CardExpiredField.propTypes = inputPropType(['exp_date']);

export default CardExpiredField;
